import {isDev} from "./util";

export const API_URL = isDev ? 'http://tesa-backend.loc/' : 'https://formulario.tesa-puertasacorazadas.com/';

